import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, switchMap, take, timeout } from 'rxjs/operators';
import { CommonService } from '../services/common.service';
import { API_CONFIG } from '../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private common: CommonService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = request.url.split('?')[0].replace(/\/$/, '');
    const apiRoots = [API_CONFIG.CORE_API, API_CONFIG.STORE_API,
      API_CONFIG.ACCOUNTMANAGEMENT_API2, API_CONFIG.IDENTITY_API, API_CONFIG.ECOMMERCE_API];
    const isApiRequest = apiRoots.some(root => url === root || url.startsWith(root + '/'));
    // The profile bootstraps tenant context; assets and identity-provider requests do not use it.
    if (!isApiRequest || url === `${API_CONFIG.IDENTITY_API}/auth/me`
        || url === `${API_CONFIG.CORE_API}/auth/login`) {
      return next.handle(request);
    }

    // Cached browser state may belong to a previous login. Wait for the fresh profile,
    // and fail rather than sending a request that the API would treat as the default tenant.
    return this.common.tenantReady$.pipe(
      filter(ready => ready),
      take(1),
      timeout(30000),
      switchMap(() => next.handle(request.clone({
        setHeaders: { instanceID: request.headers.get('instanceId') || this.common.tenantId }
      })))
    );
  }
}
